// https://github.com/segmentio/is-url
import isUrl from 'is-url'
export default isUrl
